import { lazyWithPreload, type LazyWithPreload } from '../../utils/lazyWithPreload';
import type { ComponentType } from 'react';

// Lazy versions of the learn pages used by the SPA at runtime. Kept separate
// from PrerenderRoutes.tsx (which imports the same components eagerly for the
// build-time prerender script) so the client bundle can route-split them.
//
// If you add/remove a learn route, update both files. The prerender test
// catches drift at build time.

interface LazyLearnRoute {
  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: LazyWithPreload<ComponentType<any>>;
}

export const LEARN_LAZY_ROUTES: LazyLearnRoute[] = [
  {
    path: '/learn/',
    Component: lazyWithPreload(() => import('./LearnHub').then((m) => ({ default: m.LearnHub }))),
  },
  {
    path: '/learn/getting-started/',
    Component: lazyWithPreload(() =>
      import('./GettingStarted').then((m) => ({ default: m.GettingStarted })),
    ),
  },
  {
    path: '/learn/features/',
    Component: lazyWithPreload(() => import('./Features').then((m) => ({ default: m.Features }))),
  },
  {
    path: '/learn/privacy/',
    Component: lazyWithPreload(() => import('./Privacy').then((m) => ({ default: m.Privacy }))),
  },
  {
    path: '/learn/sync/',
    Component: lazyWithPreload(() => import('./Sync').then((m) => ({ default: m.Sync }))),
  },
  {
    path: '/learn/install/',
    Component: lazyWithPreload(() => import('./Install').then((m) => ({ default: m.Install }))),
  },
  {
    path: '/learn/faq/',
    Component: lazyWithPreload(() => import('./Faq').then((m) => ({ default: m.Faq }))),
  },
  {
    path: '/learn/authoring/',
    Component: lazyWithPreload(() =>
      import('./Authoring').then((m) => ({ default: m.Authoring })),
    ),
  },
  {
    path: '/learn/authoring/builder/',
    Component: lazyWithPreload(() =>
      import('./AuthoringBuilder').then((m) => ({ default: m.AuthoringBuilder })),
    ),
  },
  {
    path: '/learn/authoring/dsl/',
    Component: lazyWithPreload(() =>
      import('./AuthoringDsl').then((m) => ({ default: m.AuthoringDsl })),
    ),
  },
  {
    path: '/learn/authoring/js/',
    Component: lazyWithPreload(() =>
      import('./AuthoringJs').then((m) => ({ default: m.AuthoringJs })),
    ),
  },
  {
    path: '/learn/authoring/ai-import/',
    Component: lazyWithPreload(() =>
      import('./AuthoringAiImport').then((m) => ({ default: m.AuthoringAiImport })),
    ),
  },
];
